import './index.scss'
import App from './App'
import store from './stores'
import {Provider} from 'react-redux'
import {applyInterceptors} from './api'
import {createRoot} from 'react-dom/client'
import './i18n.js'

const root = createRoot(document.getElementById('root'))

root.render(
    <Provider store={store}>
        <App/>
    </Provider>
)

applyInterceptors(store)
